import service from "../../request/request"
export function vehicle_drop_down_list(vin) {
    return service({
        url: "/api/net_connection/vehicle_drop_down_list",
        method: 'POST',
    })
}
//获取车辆基本信息
export function vehicle_details(vin) {
    return service({
        url: "/api/net_connection/vehicle_details",
        method: 'POST',
        data: {
            row: {
                vin:vin,
            }
        }
    })
}